export const environment = {
  production: true,
  apiUrl: 'https://api.onlyusedtesla.com',
  featureXEnabled: true,
  country: 'USA', //UK or CA
  referer: 'https://onlyusedtesla.com/',
  authentication: true,
  STRIPE_PK: 'pk_live_Kxt2ezjESxY6U9zTI0Rr74gZ',
  GOOGLE_TAG_MANAGER_ID: 'GTM-KZFMZNT',
  azureOpenAIApiKey: 'BEDqu74ta6LUeXHmp7A4IorgyZiWfWDuWEL53sW492zWHVMTVlXoJQQJ99BFACYeBjFXJ3w3AAABACOGPOq3',
  azureOpenAIDeploymentName: 'gpt-35-turbo',
  azureOpenAiEndpoint: 'https://out-ai.openai.azure.com/',
  azureOpenAiSemanticConfiguration: 'rag-1753363465311-semantic-configuration',
  azureAiSearchEndpoint: 'https://outai.search.windows.net',
  azureAiSearchIndex: 'rag-1753363465311',
  azureAiSearchApiKey: 'y3XYk9HczLTy3eYToJXVoxGq5WL89vzPBhZOZ7vs4YAzSeCzWboz',
};
